<form
  class="field-dialog__content__scroll recurrence-dialog-general"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  fxLayout="column"
  name="form"
  [formGroup]="recurrenceForm"
  fusePerfectScrollbar
>
  <fc-location-input
    [control]="recurrenceForm.get('location')"
    [requiredMark]="true"
    [preloadOptions]="true"
    [translateErrorPrefix]="'RECURRENCES.DIALOG.TABS.GENERAL.LOCATION'"
  >
  </fc-location-input>

  <div class="row-wrapper">
    <fc-segment-input
      [control]="recurrenceForm.get('segment')"
      [requiredMark]="true"
      [preloadOptions]="true"
      [translateErrorPrefix]="'RECURRENCES.DIALOG.TABS.GENERAL.SEGMENT'"
    >
    </fc-segment-input>

    <fc-maintenance-type-input
      [control]="recurrenceForm.get('maintenanceType')"
      [requiredMark]="true"
      [preloadOptions]="true"
      [translateErrorPrefix]="'RECURRENCES.DIALOG.TABS.GENERAL.MAINTENANCE_TYPE'"
    >
    </fc-maintenance-type-input>
  </div>

  <fc-company-input [control]="recurrenceForm.get('company')" [requiredMark]="false" [preloadOptions]="true">
  </fc-company-input>

  <fc-text-area-input
    [label]="'RECURRENCES.DIALOG.DESCRIPTION' | translate"
    [control]="recurrenceForm.get('message')"
    [requiredMark]="true"
    [maxLength]="1500"
    [translateErrorPrefix]="'RECURRENCES.DIALOG.TABS.GENERAL.DESCRIPTION'"
  >
  </fc-text-area-input>

  <div class="row-wrapper">
    <div class="field-wrapper">
      <fc-date-input
        [control]="recurrenceForm.get('from')"
        [min]="minDate"
        [label]="'RECURRENCES.DIALOG.START_AT' | translate"
        translateErrorPrefix="RECURRENCES.DIALOG.TABS.GENERAL.FROM"
      ></fc-date-input>
    </div>
    <div class="field-wrapper">
      <fc-date-input
        [control]="recurrenceForm.get('until')"
        [min]="recurrenceForm.get('from').value"
        [label]="'RECURRENCES.DIALOG.END_AT' | translate"
        translateErrorPrefix="RECURRENCES.DIALOG.TABS.GENERAL.UNTIL"
      ></fc-date-input>
    </div>
  </div>

  <div class="row-wrapper">
    <div class="field-wrapper">
      <fc-outlined-select
        class="interval"
        [control]="recurrenceForm.get('interval')"
        [label]="'RECURRENCES.DIALOG.REPEAT' | translate"
        [predefinedOptions]="repeatOptions"
      ></fc-outlined-select>
    </div>

    <div class="field-wrapper">
      <fc-outlined-input
        [isNumber]="true"
        [required]="true"
        [hideErrorTextEllipses]="true"
        [control]="recurrenceForm.get('every')"
        [label]="'RECURRENCES.DIALOG.EACH' | translate"
      >
        <ng-container *ngIf="recurrenceForm.get('every').hasError('required')">
          {{ 'RECURRENCES.DIALOG.TABS.GENERAL.EVERY.REQUIRED_FIELD' | translate }}
        </ng-container>
        <ng-container *ngIf="recurrenceForm.get('every').hasError('min')">
          {{ 'RECURRENCES.DIALOG.TABS.GENERAL.EVERY.MIN_VALUE' | translate }}
        </ng-container>
        <ng-container *ngIf="recurrenceForm.get('every').hasError('max')">
          {{ 'RECURRENCES.DIALOG.TABS.GENERAL.EVERY.MAX_VALUE' | translate }}
        </ng-container>
        <ng-container *ngIf="recurrenceForm.get('every').hasError('integer')">
          {{ 'RECURRENCES.DIALOG.TABS.GENERAL.EVERY.INTEGER_VALUE' | translate }}
        </ng-container>
      </fc-outlined-input>
      <ng-container>
        <div class="hint" *ngIf="recurrenceForm.get('interval').value === 'daily'">
          <ng-container *ngIf="recurrenceForm.get('every').value == 1">
            {{ 'RECURRENCES.DIALOG.DAY' | translate }}
          </ng-container>
          <ng-container *ngIf="recurrenceForm.get('every').value != 1">
            {{ 'RECURRENCES.DIALOG.DAYS' | translate }}
          </ng-container>
        </div>
        <div class="hint" *ngIf="recurrenceForm.get('interval').value === 'weekly'">
          <ng-container *ngIf="recurrenceForm.get('every').value == 1">
            {{ 'RECURRENCES.DIALOG.WEEK' | translate }}
          </ng-container>
          <ng-container *ngIf="recurrenceForm.get('every').value != 1">
            {{ 'RECURRENCES.DIALOG.WEEKS' | translate }}
          </ng-container>
        </div>
        <div class="hint" *ngIf="recurrenceForm.get('interval').value === 'monthly'">
          <ng-container *ngIf="recurrenceForm.get('every').value == 1">
            {{ 'RECURRENCES.DIALOG.MONTH' | translate }}
          </ng-container>
          <ng-container *ngIf="recurrenceForm.get('every').value != 1">
            {{ 'RECURRENCES.DIALOG.MONTHS' | translate }}
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div class="field-wrapper">
      <div @fade *ngIf="recurrenceForm.get('interval').value !== 'daily'">
        <fc-outlined-select
          class="weekday"
          *ngIf="recurrenceForm.get('interval').value === 'weekly'"
          [control]="recurrenceForm.get('weekday')"
          [label]="'RECURRENCES.DIALOG.REPEAT' | translate"
          [predefinedOptions]="weekdayOptions"
        ></fc-outlined-select>

        <fc-outlined-input
          class="day-of-month"
          [isNumber]="true"
          [required]="true"
          [hideErrorTextEllipses]="true"
          [control]="recurrenceForm.get('dayOfMonth')"
          [label]="'RECURRENCES.DIALOG.DAY_OF_MONTH' | translate"
          *ngIf="recurrenceForm.get('interval').value === 'monthly'"
        >
          <ng-container *ngIf="recurrenceForm.get('dayOfMonth').hasError('required')">
            {{ 'RECURRENCES.DIALOG.TABS.GENERAL.DAY_OF_MONTH.REQUIRED_FIELD' | translate }}
          </ng-container>
          <ng-container *ngIf="recurrenceForm.get('dayOfMonth').hasError('min')">
            {{ 'RECURRENCES.DIALOG.TABS.GENERAL.DAY_OF_MONTH.MIN_VALUE' | translate }}
          </ng-container>
          <ng-container *ngIf="recurrenceForm.get('dayOfMonth').hasError('max')">
            {{ 'RECURRENCES.DIALOG.TABS.GENERAL.DAY_OF_MONTH.MAX_VALUE' | translate }}
          </ng-container>
          <ng-container *ngIf="recurrenceForm.get('dayOfMonth').hasError('integer')">
            {{ 'RECURRENCES.DIALOG.TABS.GENERAL.DAY_OF_MONTH.INTEGER_VALUE' | translate }}
          </ng-container>
        </fc-outlined-input>
      </div>
    </div>
  </div>

  <div class="row-wrapper">
    <mat-slide-toggle
      *ngIf="recurrenceForm.get('interval').value !== 'weekly'"
      formControlName="skipWeekend"
      (change)="skipWeekendChange()"
      @fade
    >
      <span *ngIf="recurrenceForm.get('skipWeekend').value === true">
        {{ 'RECURRENCES.DIALOG.SKIP_WEEKEND' | translate }}
      </span>
      <span *ngIf="recurrenceForm.get('skipWeekend').value === false">
        {{ 'RECURRENCES.DIALOG.NOT_SKIP_WEEKEND' | translate }}
      </span>
    </mat-slide-toggle>
  </div>

  <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
    <p class="explanation">{{ recurrenceForm.getRawValue() | recurrenceDescriptionHumanizer }}</p>
  </div>

  <div class="alert-message" *ngIf="recurrenceForm.get('dayOfMonth').value > 28">
    <span>
      {{ 'RECURRENCES.DIALOG.DAY_NOT_EXISTS_ALL_MONTHS_MESSAGE' | translate }}
    </span>
  </div>

  <div class="alert-message" *ngIf="isFromSateAdjusted">
    <span>
      {{ 'RECURRENCES.DIALOG.FROM_DATE_ADJUSTED_MESSAGE' | translate }}
    </span>
  </div>
</form>
